// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dcjv","colMin":"styles_colMin__Bb90U"};